import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2df0a1d6")

_pushScopeId("data-v-2df0a1d6")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Algorithm Visualizer", -1)
const _hoisted_3 = { class: "is-flex cards-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageCard = _resolveComponent("ImageCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageCards, (card) => {
        return (_openBlock(), _createBlock(_component_ImageCard, {
          imageSrc: card.imageSrc,
          name: card.name,
          routePath: card.routePath,
          description: card.description,
          key: card.routePath
        }, null, 8, ["imageSrc", "name", "routePath", "description"]))
      }), 128))
    ])
  ]))
})